/**
 * Object Storage 공개 자산 URL 헬퍼.
 *
 * 클라우드별 origin:
 *   NCP  → https://kr.object.ncloudstorage.com
 *   FNCP → https://kr.object.fin-ncloudstorage.com
 *
 * 이 값을 소스에 하드코딩하면 NCP↔FNCP 이관마다 수십 개 파일을 되돌려야 한다
 * (2026-08-04 포팅 때 실제로 38개 파일을 fin→NCP로 복구했다).
 * 그래서 origin만 env로 빼고, 코드는 양쪽 클라우드에서 동일하게 둔다.
 *
 * `NEXT_PUBLIC_` 접두사이므로 클라이언트 번들에 **빌드 시점에 인라인**된다.
 * 따라서 값을 바꾸면 이미지 재빌드가 필요하다.
 * env가 없으면 현행 NCP 운영값으로 동작한다 (기존 동작 보존).
 *
 * @see md/FNCP_WEB_SERVER_AGENTS.md — 독립성 체크포인트
 */
export const OS_PUBLIC_ORIGIN =
    process.env.NEXT_PUBLIC_OBJECT_STORAGE_ORIGIN?.replace(/\/+$/, "") ||
    "https://kr.object.ncloudstorage.com";

/** 공개 버킷 (로고·메타 등 무인증 자산). ACL public-read 필수 */
export const PUBLIC_BUCKET = "riskweather-public";

/**
 * 공개 버킷 자산의 절대 URL을 만든다.
 * @param path 버킷 내부 경로 (예: `logos/005930.png`)
 */
export function getPublicAssetUrl(path: string) {
    return `${OS_PUBLIC_ORIGIN}/${PUBLIC_BUCKET}/${path.replace(/^\/+/, "")}`;
}

/** 로고를 못 찾았을 때 쓰는 대체 이미지 */
export const ERROR_LOGO_URL = getPublicAssetUrl("logos/errorLogo.png");
